module.exports = __webpack_public_path__ + "static/sadfie-381149e7716831e5844a3084397fac35.jpg";